export const iconFontAwesomeEditingEyeDropper = (
	<i className="fa-solid fa-eye-dropper"></i>
);
